import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiPromoCodeService from "../../../../core/api/api.promoCode";
import publicApi from "../../../../core/api/api.public";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import { DateObject } from "react-multi-date-picker";
import { persian } from "../../_Components/customLocale";

import SwalMessage from "../../_Components/SwalMessage";
import { useNavigate, useLocation } from "react-router-dom";
import { MenuItem } from "@mui/material";
import moment from "moment-jalaali";
import { NumericFormat } from "react-number-format";
import { tools } from "../../../../core/utils/tools";
// moment.locale("fa");
// moment.loadPersian();

const selectStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 10000,
  }),
};

export const NewPromoCodeModal = ({
  showModalPromoCode,
  setShowModalPromoCode,
  selectedPromoCodeId,
}) => {
  let location = useLocation();
  // let navigate = useNavigate();

  let handleClose = (e) => {
    setShowModalPromoCode(false);
    // location?.state?.promoCodeId ?props.callback(null) :props.callback(getValues("Code"));
  };
  // const { match } = props;
  // let params = match.params;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      minimumDate: {},
      maximumDate: {},
      minimumDateCheckin: {},
      maximumDateCheckin: {},
      minimumDateCheckOut: {},
      maximumDateCheckOut: {},
      promoCodeId: 0,
    },
  });

  const [listData, setListData] = useState([]);
  const [allAgentList, setAllAgentList] = useState([]);
  const [allCommisionList, setAllCommisionList] = useState([]);
  const [locationS, setlocationS] = useState(location?.state?.promoCodeId);
  const [copySuccess, setCopySuccess] = useState(null);
  const [promoCodeActive, setPromoCodeActive] = useState(false);
  const [selectDatePicker, setSelectDatePicker] = useState();

  const [promoCodeSelectedReadOnly, setpromoCodeSelectedReadOnly] =
    useState(false);
  const [statusEditField, setStatusEditField] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const resultPromoCategory =
          await ApiPromoCodeService.getAllPromoCategory({
            TypePromoCategory: 1,
          });
        setListData(resultPromoCategory);

        // EditModal
        if (selectedPromoCodeId != 0) {
          const rest = await ApiPromoCodeService.get(selectedPromoCodeId);
          setStatusEditField(true);

          const expireDate = tools.checkInputDateAndReturnProperFormattedDate(
            rest.expireDate
          );
          setValue("expireDate", expireDate);

          // console.log("restzah=",rest);
          // if (rest.created != "0001-01-01T00:00:00") {
          //     let dateCreated = rest.created.split(' ')[0];
          //     publicApi.getDateTimeAddDay({ addDay: 21, createTime: dateCreated }).then(resultdate => {
          //         let minimumDateV = {
          //             year: parseInt(resultdate.dateTime.split('/')[0]),
          //             month: parseInt(resultdate.dateTime.split('/')[1]),
          //             day: parseInt(resultdate.dateTime.split('/')[2])
          //         };
          //         let maximumDateV = {
          //             year: parseInt(resultdate.dateTimeAfterXDays.split('/')[0]),
          //             month: parseInt(resultdate.dateTimeAfterXDays.split('/')[1]),
          //             day: parseInt(resultdate.dateTimeAfterXDays.split('/')[2])
          //         };
          //         setValue("minimumDate", minimumDateV);
          //         setValue("maximumDate", maximumDateV);
          //     });
          // }

          setValue("PromoCategoryId", rest.promoCategory.id);
          setPromoCodeActive(true);
          if (!_.isEmpty(rest.promoCodeUser)) {
            setValue("userFirstname", rest.promoCodeUser[0].userFirstname);
            setValue("userLastName", rest.promoCodeUser[0].userLastName);
            setValue("userPhoneNumber", rest.promoCodeUser[0].userPhoneNumber);

            const userCheckInDate =
              tools.checkInputDateAndReturnProperFormattedDate(
                rest.promoCodeUser[0].userCheckInDate
              );
            setValue("userCheckInDate", userCheckInDate);

            const userCheckOutDate =
              tools.checkInputDateAndReturnProperFormattedDate(
                rest.promoCodeUser[0].userCheckOutDate
              );
            setValue("userCheckOutDate", userCheckOutDate);

            setValue("passengersCount", rest.promoCodeUser[0].passengersCount);
            setValue("Code", rest.code);
            setValue("promoCodeId", rest.id);
            setPromoCodeActive(true);
          }
        } else {
          // CreateModal
          const {
            formattedToday,
            formattedArbitaryDate: formatted21DaysFromNow,
          } = tools.setCustomDate(21);
          setValue("expireDate", formatted21DaysFromNow);
          setValue("userCheckInDate", formattedToday);
          setValue("userCheckOutDate", formatted21DaysFromNow);
          // setValue("userCheckInDate", formattedToday);
          // setValue("userCheckOutDate", formatted21DaysFromNow);
          // console.log("expireDate", formatted21DaysFromNow)
          // publicApi.getDateTimeAddDay({ addDay: 21, createTime: "" }).then(resultdate => {
          //     let minimumDateV = {
          //         year: parseInt(resultdate.dateTime.split('/')[0]),
          //         month: parseInt(resultdate.dateTime.split('/')[1]),
          //         day: parseInt(resultdate.dateTime.split('/')[2])
          //     };
          //     let maximumDateV = {
          //         year: parseInt(resultdate.dateTimeAfterXDays.split('/')[0]),
          //         month: parseInt(resultdate.dateTimeAfterXDays.split('/')[1]),
          //         day: parseInt(resultdate.dateTimeAfterXDays.split('/')[2])
          //     };
          //     console.log("minimumDateV=",minimumDateV);
          //     console.log("maximumDate=",maximumDateV);
          //     setValue("minimumDate", minimumDateV);
          //     setValue("maximumDate", maximumDateV);
          //     setValue("expireDate",maximumDateV);
          //     setValue("userCheckInDate",minimumDateV);
          //     setValue("userCheckOutDate",maximumDateV);
          // });
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    try {
      if (
        _.isUndefined(data.userPhoneNumber) ||
        Array.from(data.userPhoneNumber)[0] != 0 ||
        data.userPhoneNumber.length < 11
      ) {
        SwalMessage({
          title: "لطفا شماره تلفن گردشگر را به صورت صحیح  وارد نمایید",
          iSsuccess: false,
        });

        return;
      } else if (
        _.isUndefined(data.PromoCategoryId) ||
        data.PromoCategoryId == 0
      ) {
        SwalMessage({
          title: "لطفا گروه تخفیف را انتخاب نمایید",
          iSsuccess: false,
        });

        return;
      } else {
        if (!_.isUndefined(data.expireDate)) {
          if (typeof data.expireDate == "object")
            data.expireDate = moment(
              data.expireDate.year +
                "/" +
                ("0" + data.expireDate.month).slice(-2) +
                "/" +
                ("0" + data.expireDate.day).slice(-2),
              "jYYYY/jM/jD"
            ).format("YYYY-M-D");
          else
            data.expireDate = moment(data.expireDate, "jYYYY/jMM/jDD").format(
              "YYYY-M-D"
            );
        }

        if (!_.isUndefined(data.userCheckOutDate)) {
          if (typeof data.userCheckOutDate == "object")
            data.userCheckOutDate = moment(
              data.userCheckOutDate.year +
                "/" +
                (data.userCheckOutDate.month < 10
                  ? "0" + data.userCheckOutDate.month
                  : data.userCheckOutDate.month) +
                "/" +
                (data.userCheckOutDate.day < 10
                  ? "0" + data.userCheckOutDate.day
                  : data.userCheckOutDate.day),
              "jYYYY/jM/jD"
            ).format("YYYY-M-D");
          else
            data.userCheckOutDate = moment(
              data.userCheckOutDate,
              "jYYYY/jMM/jDD"
            ).format("YYYY-M-D");
        }
        if (!_.isUndefined(data.userCheckInDate)) {
          if (typeof data.userCheckInDate == "object")
            data.userCheckInDate = moment(
              data.userCheckInDate.year +
                "/" +
                (data.userCheckInDate.month < 10
                  ? "0" + data.userCheckInDate.month
                  : data.userCheckInDate.month) +
                "/" +
                (data.userCheckInDate.day < 10
                  ? "0" + data.userCheckInDate.day
                  : data.userCheckInDate.day),
              "jYYYY/jM/jD"
            ).format("YYYY-M-D");
          else
            data.userCheckInDate = moment(
              data.userCheckInDate,
              "jYYYY/jMM/jDD"
            ).format("YYYY-M-D");
        }
      }

      const resultPromoCategory =
        await ApiPromoCodeService.createandEditPromoCode({
          InputPromoCode: data,
        });

      SwalMessage({
        title:
          resultPromoCategory.data == 1
            ? JSON.parse(resultPromoCategory.message).Message
            : resultPromoCategory.message,
        iSsuccess:
          resultPromoCategory.data == 1 || resultPromoCategory.data == 2
            ? true
            : false,
        timer: 10000,
      });
      if (resultPromoCategory.data == 1) {
        setValue("Code", JSON.parse(resultPromoCategory.message).PromoCode);
        setPromoCodeActive(true);
        handleClose();
        document.getElementById("submitButton").click();
      } else console.log(data);
      console.log("resultPromoCategory ", resultPromoCategory);
    } catch (error) {
      console.log("error=", error);
    }
  };

  function handleChangeMulti(event) {
    setValue("agentName", event);
  }

  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess("Copied!");
      SwalMessage({ title: "کد تخفیف کپی شد", iSsuccess: true, timer: 10000 });
    } catch (err) {
      setCopySuccess("Failed to copy!");
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalPromoCode} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {" "}
              {selectedPromoCodeId != 0
                ? "ویرایش کد تخفیف"
                : "ایجاد کد تخفیف جدید"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {promoCodeActive && (
              <Col xs="12">
                <Controller
                  name="Code"
                  control={control}
                  rules={{}}
                  render={({ field: { onChange, value } }) => (
                    <div className="d-flex align-items-center">
                      <TextField
                        label="کد تخفیف"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        disabled
                      />

                      <span
                        className="btn btn-light-primary btn-sm mr-2 btn-icon mt-2 ml-2 "
                        onClick={(e) => copyToClipBoard(getValues("Code"))}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-dark"
                        title="کپی تو کلیپ بورد"
                        data-bs-delay-hide="1000"
                      >
                        <i class="fas fa-clipboard"></i>
                      </span>
                    </div>
                  )}
                />
              </Col>
            )}
            <Col xs="12" className="mt-5">
              <Controller
                name="expireDate"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <ShamsiDatePicker
                    value={value}
                    onChange={onChange}
                    disabled={statusEditField}
                    placeholder="تاریخ انقضا"
                    minDate={new DateObject({ calendar: persian })}
                    maxDate={new DateObject({ calendar: persian }).add(
                      21,
                      "days"
                    )}
                  />
                )}
              />
              {/* <Controller
                                    name="expireDate"
                                    control={control}
                                    rules={{  }}
                                    style={{zIndex:'200 !important'}}
                                    render={({ field: { onChange, value } }) => (
                                        <DatePicker
                                        value={value}
                                        onChange={onChange}
                                        locale="fa"
                                        shouldHighlightWeekends
                                        minimumDate={getValues("minimumDate")}
                                        maximumDate={getValues("maximumDate")}
                                      
                                        
                                        renderInput={(props) => {
                                          return (
                                            <TextField
                                              {...props}
                                              mask="____/__/__"
                                              value={
                                                value
                                                  ? `${value.year +
                                                  `/` +
                                                  ("0" + value.month).slice(-2) +
                                                  `/` +
                                                  ("0" + value.day).slice(-2)}`
                                                  : ""
                                              }
                                              className="w-100"
                                              variant="outlined"
                                              label="تاریخ انقضا"
                                              size="small"
                                              margin="normal"
                                              disabled={statusEditField}
                                        //    style={selectStyles}

                                        onClick={()=>{setSelectDatePicker("expireDate")}}
                                     
                                            // onChange={onChange}
                                            />
                                          );
                                        }}
                                      />
                                    )}
                                /> */}
            </Col>
            <Col xs="12" className="mt-2 require_input">
              <Controller
                name="PromoCategoryId"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    // error={errors.PromoCategoryId ? "true" : "false"}
                    select
                    label="انتخاب گروه تخفیف"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    disabled={promoCodeSelectedReadOnly}
                    className={` mt-5 require_input ${errors.PromoCategoryId && "required_error_input"}`}
                  >
                    {listData?.map(
                      (item, index) =>
                        item.isActive == true && (
                          <MenuItem key={index} value={item.id}>
                            {item.promoCategoryName}{" "}
                          </MenuItem>
                        )
                    )}
                  </TextField>
                )}
              />

              {errors.PromoCategoryId && (
                <div class="mt-2 text-danger">
                  لطفا گروه تخفیف را وارد نمایید
                </div>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="userFirstname"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="نام گردشگر"
                    margin="normal"
                    className="mt-5"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                  />
                )}
              />
            </Col>
            <Col xs="12">
              <Controller
                name="userLastName"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="نام خانوادگی گردشگر"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                  />
                )}
              />
            </Col>
            <Col xs="12" className="mb-4">
              <Controller
                name="userPhoneNumber"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <NumericFormat
                    customInput={TextField}
                    label="شماره تلفن همراه گردشگر "
                    size="small"
                    margin="normal"
                    value={value || ""}
                    className={`mb-1  require_input ${errors.userPhoneNumber && "required_error_input"}`}
                    variant="outlined"
                    inputProps={{ maxLength: 11 }}
                    // error={errors.userPhoneNumber ? "false" : "true"}
                    // thousandSeparator=","
                    // decimalScale="0"
                    //prefix=" تومان "
                    //maxLength={value[0] === '0' ? 13 : 12}
                    format="#### ### ####"
                    disabled={statusEditField}
                    onChange={onChange}
                  />
                )}
              />
              {errors.userPhoneNumber && (
                <div class="mt-2 text-danger">
                  لطفا شماره تلفن همراه گردشگر را وارد نمایید
                </div>
              )}
            </Col>
            <Col xs="12" sm="12" lg="12" className="mt-5">
              <Controller
                name="userCheckInDate"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <ShamsiDatePicker
                    value={value}
                    onChange={onChange}
                    minDate={new DateObject({ calendar: persian })}
                    maxDate={new DateObject({ calendar: persian }).add(
                      21,
                      "days"
                    )}
                    placeholder="تاریخ ورود"
                  />
                )}
              />
              {/* <Controller
                                    name="userCheckInDate"
                                    control={control}
                                    rules={{  }}
                                    render={({ field: { onChange, value } }) => (
                                        <DatePicker
                                        value={value}
                                        onChange={onChange}
                                        locale="fa"
                                        shouldHighlightWeekends
                                         minimumDate={getValues("minimumDateCheckin")}
                                         maximumDate={getValues("maximumDateCheckin")}
                                        // minimumDate={getValues("minimumDate")}
                                        // // maximumDate={getValues("maximumDate")}
                                     
                                        style={{zIndex:0}}
                                        renderInput={(props) => {
                                          return (
                                            <TextField
                                              {...props}
                                              mask="____/__/__"
                                              value={
                                                value
                                                  ? `${value.year +
                                                  `/` +
                                                  ("0" + value.month).slice(-2) +
                                                  `/` +
                                                  ("0" + value.day).slice(-2)}`
                                                  : ""
                                              }
                                              className="w-100"
                                              variant="outlined"
                                              label="تاریخ ورود"
                                              size="small"
                                              margin="normal"
                                            //   style={selectStyles}
                                            onClick={()=>{setSelectDatePicker("userCheckInDate")}}
                                           
                                            // onChange={onChange}
                                            />
                                          );
                                        }}
                                      />
                                    )}
                                /> */}
            </Col>
            <Col xs="12" sm="12" lg="12" className="mt-5">
              <Controller
                name="userCheckOutDate"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <ShamsiDatePicker
                    value={value}
                    onChange={onChange}
                    placeholder="تاریخ خروج"
                    minDate={new DateObject({ calendar: persian })}
                    maxDate={new DateObject({ calendar: persian }).add(
                      21,
                      "days"
                    )}
                  />
                )}
              />
              {/* <Controller
                                    name="userCheckOutDate"
                                    control={control}
                                    rules={{  }}
                                    render={({ field: { onChange, value } }) => (
                                        <DatePicker
                                        value={value}
                                        onChange={onChange}
                                        locale="fa"
                                        shouldHighlightWeekends
                                         minimumDate={getValues("minimumDateCheckOut")}
                                         maximumDate={getValues("maximumDateCheckOut")}
                                        //  minimumDate={getValues("minimumDate")}
                                        //  maximumDate={getValues("maximumDate")}
                                        // 
                                        style={{zIndex:0}}
                                        renderInput={(props) => {
                                          return (
                                            <TextField
                                              {...props}
                                              mask="____/__/__"
                                              value={
                                                value
                                                  ? `${value.year +
                                                  `/` +
                                                  ("0" + value.month).slice(-2) +
                                                  `/` +
                                                  ("0" + value.day).slice(-2)}`
                                                  : ""
                                              }
                                              className="w-100"
                                              variant="outlined"
                                              label="تاریخ خروج"
                                              size="small"
                                              margin="normal"
                                              onClick={()=>{setSelectDatePicker("userCheckOutDate")}}
                                             
                                            //   style={selectStyles}

                                            // onChange={onChange}
                                            />
                                          );
                                        }}
                                      />
                                    )}
                                /> */}
            </Col>
            <Col xs="12">
              <Controller
                name="passengersCount"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="تعداد مسافران بزرگسال"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    type="number"
                    value={value || ""}
                    onChange={onChange}
                  />
                )}
              />
            </Col>
            <Col xs="12" className="bg-light-warning p-3 rounded-lg shadow-sm">
              <div>
                <p>
                  توجه داشته باشید کد تخفیف ایجاد شده پس از تاریخ انقضا قابلیت
                  استفاده را ندارد!
                </p>
              </div>
              <div>
                <p>در وارد کردن شماره همراه گردشگر دقت فرمایید!</p>
              </div>{" "}
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon />
              ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
